<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";
import { RouterView } from "vue-router";
import { getEnvConfig } from "~/services/appConfig";
import { getModeDisplay } from "~/utils/miscUtils";
import PortalTopBar from "../components/PortalTopBar.vue";
import SideMenu from "../components/SideMenu.vue";

// Cache the environment config for performance
const envConfig = getEnvConfig();

const showWarning = envConfig.env !== "live";

onMounted(() => {
  // add class to the body when the page is loaded
  document.body.classList.add("hmb");
});

onUnmounted(() => {
  document.body.classList.remove("hmb");
});
</script>

<template>
  <el-container class="mainContainer hmb">
    <div v-if="showWarning" class="warningContainer">
      <div class="warning">{{ getModeDisplay() }}</div>
    </div>
    <el-header class="border homeHeader">
      <PortalTopBar />
    </el-header>

    <el-container class="hmbContainer">
      <SideMenu />
      <el-main class="border homeMain">
        <RouterView />
      </el-main>
    </el-container>
  </el-container>
</template>
<style lang="less">
body.hmb {
  --el-font-size-base: 1rem;
  --el-color-primary-dark-2: #62a3d2;
  --el-color-primary-dark-3: #4697d2;
}
.hmb {
  .hmbContainer {
    display: grid;
    overflow-y: hidden;
    grid-template-columns: auto 1fr;
  }

  .el-header {
    --el-header-height: 70px;
  }

  .homeMain {
    display: grid;
    grid-template-rows: auto;
    background-color: white;
  }

  &.mainContainer {
    .warningContainer {
      width: 100%;
      z-index: 10;
      color: var(--el-color-primary-dark);
      background-color: var(--subheading-color);
      .warning {
        margin: auto;
        text-align: center;
        opacity: 0.4;
      }
    }

    .homeHeader {
      background-color: var(--el-color-primary-dark-2);
    }
  }
  .right {
    margin-top: 0.25em;
    align-items: end;
    display: flex;
    flex-direction: column-reverse;
  }

  .el-dialog {
    background-color: var(--el-color-primary-light-9);
  }
}

body.hmb {
  .el-message-box {
    .el-message-box__title {
      font-size: 1.2rem;
    }
    .el-message-box__message p {
      font-size: 1.1rem;
      line-height: normal;
      margin: 0 1em 0 0.5em;
    }
    .el-button {
      font-size: 1rem;
    }
  }

  // need both so the icon and text are the same size
  .el-message,
  .el-message__content {
    font-size: 1.1rem;
  }

  .el-checkbox__label {
    font-size: 1rem;
  }
}
</style>
